module.exports = __webpack_public_path__ + "static/media/logo_agribank.0f896776.svg";